import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"
import LocaleOverviewHotspotContent from "composer/views/locale/LocaleOverviewHotspotContent.jsx"

import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Icon,
  Divider,
  Avatar,
} from '@material-ui/core';

class LocaleOverviewHotspot extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  component(componentData) {
    return (
      <><span><br /></span>
      <div style={{ border: "2px solid #5F5F5F", borderRadius: "10px" }}>
        <ListItem key={componentData.id} alignItems="flex-start">
          <ListItemAvatar>
            <Icon>{Config.GET_HOTSPOT_CONTENT_CONFIG(parseInt(componentData.kind))['icon']}</Icon>
          </ListItemAvatar>
          <ListItemText style={{ wordWrap: "break-word"}}>
            <LocaleOverviewHotspotContent root={this.props.root} parent={this} contentData={componentData} />
          </ListItemText>
        </ListItem>
      </div></>
    );
  }

  render() {
    return (
      <div>
        {/*< Divider variant="middle" style={{backgroundcolor:"#00FF00"}}/ >*/}
        <Card style={{margin:"0 0 16px 0"}} elevation={0}>
          <CardHeader
            title={this.props.hotspotData.name}
          />
          <CardContent>
            <List>
              {this.props.hotspotData.component_list.map( (row, i) => {
                return (
                  this.component(row)
                );
              })}
            </List>
          </CardContent>
        </Card>
      </div>
    )
  }
}

export default LocaleOverviewHotspot;
